import React from "react";
import * as LucideIcons from "lucide-react";

function Icon({ name, size = 18 }) {
    const Cmp = LucideIcons[name] || LucideIcons.Code2;
    return <Cmp size={size} />;
}

export default function Skills({ skills = [] }) {
    const grouped = skills.reduce((acc, s) => {
        (acc[s.category] = acc[s.category] || []).push(s);
        return acc;
    }, {});
    const categories = Object.keys(grouped);

    return (
        <section id="skills" data-testid="skills-section" className="relative py-24 md:py-32 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="mono-label mb-4">02 · Capabilities</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tighter">
                            Tools that I <span className="text-brand">wield</span>.
                        </h2>
                    </div>
                    <p className="text-ink-200 max-w-md">
                        End-to-end execution across full-stack web engineering, cloud infrastructure, and AI automations. Selecting the optimal tool for each architectural requirement.
                    </p>
                </div>

                <div className="space-y-12">
                    {categories.map((cat) => (
                        <div key={cat} data-testid={`skills-category-${cat.toLowerCase()}`}>
                            <div className="flex items-center gap-4 mb-6">
                                <span className="mono-label">{cat}</span>
                                <span className="flex-1 h-px bg-white/5" />
                                <span className="mono-label text-ink-300">{String(grouped[cat].length).padStart(2, "0")}</span>
                            </div>
                            <div className="flex flex-wrap gap-2.5">
                                {grouped[cat].map((s) => (
                                    <div
                                        key={s.id || s.name}
                                        data-testid={`skill-${s.name.toLowerCase().replace(/\s|\//g, "-")}`}
                                        className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full border border-white/10 bg-ink-800/40 hover:border-brand/50 hover:bg-ink-800 hover:-translate-y-0.5 transition-all"
                                    >
                                        <span className="text-brand">
                                            <Icon name={s.icon} size={14} />
                                        </span>
                                        <span className="text-white text-sm font-medium">{s.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
